import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import store from './redux/FJStore';
import { Provider } from 'react-redux';
import './common/css/light.less';
import FJTheme from './FJTheme';
import { ThemeProvider } from '@mui/material/styles';
import { RELEASE } from './constants/FJEvnConstant.js';
import * as Sentry from '@sentry/react';
const rootId = window.isEditPage ? 'ai-tool-root' : 'root';
console.log(rootId);

const currentFrom = import.meta.env.VITE_FROM; // 当前项目
if (currentFrom !== 'edit_page') {
    import('./index.less');
}

const environment = import.meta.env.MODE;
if (!window.isEditPage && Sentry && environment === RELEASE) {
    Sentry.init({
        dsn: 'https://049007229ec840ac99789fa015c85fa6@senty.smartvideomaker.com/15',
        tracesSampleRate: 1.0,
    });
}

ReactDOM.createRoot(document.getElementById(rootId)).render(
    <ThemeProvider theme={FJTheme}>
        <Provider store={store}>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </Provider>
    </ThemeProvider>,
);
